import { Text, TextElementTypes } from '@picsart/text';
import { Typography, FontWeights } from '@picsart/cascade';
import { Button, ButtonSizeLG, ButtonVariants, ButtonSkinPrimary } from '@picsart/button';
import { useTranslation } from 'react-i18next';

import analytics from '../../../services/analytics';

import OpenAiWriterButton from './OpenAiWriterButton';
import GenerateButton from './GenerateButton';
import useStyles from './styles';

const STICKY_HEADER_HEIGHT = 80;

function GenerateExample() {
  const classes = useStyles();
  const { t } = useTranslation();
  const scrollToTop = () => {
    analytics.pageClick({
      category_name: 'ai_writer',
      action_type: 'see_all_ai_writer_tools',
      page_path: window.location.pathname,
    });
    const el = document.querySelector('#CopywriterToolsSection');
    const offset = window.pageYOffset + el.getBoundingClientRect().top - STICKY_HEADER_HEIGHT;

    window.scrollTo({ top: offset, behavior: 'smooth' });
  };

  return (
    <div className={classes.root}>
      <Text
        elementType={TextElementTypes.H2}
        weight={FontWeights.SemiBold}
        size={Typography.t7}
        className={classes.text}
      >
        {t('generalLanding.genExample.title')}
      </Text>
      <GenerateButton />

      <div className={classes.btnContainer}>
        <OpenAiWriterButton />
        <Button
          className={classes.toolsBtn}
          size={ButtonSizeLG}
          variant={ButtonVariants.Outline}
          skin={ButtonSkinPrimary}
          onClick={scrollToTop}
        >
          {t('generalLanding.genExample.btnAll')}
        </Button>
      </div>
    </div>
  );
}

export default GenerateExample;
